import { API_URL } from '../environment';
import Giftcard from '../model/Giftcard';
import fetcher from '../utils/fetcher';

export const getGiftcardsList = async (companyId: string) => {
  return fetcher(`${API_URL}/v1/company/${companyId}/giftCards`, {
    method: 'GET',
  }).then((data) => data as Giftcard[]);
};

export const getGiftcard = async (companyId: string, giftcardId: string) => {
  return fetcher(`${API_URL}/v1/company/${companyId}/giftCards/${giftcardId}`, {
    method: 'GET',
  }).then((data) => data as Giftcard);
};

export const updateGiftcard = async (
  companyId: string,
  giftcardId: string,
  giftcard: Partial<Giftcard>,
) => {
  return fetcher(`${API_URL}/v1/company/${companyId}/giftcards/${giftcardId}`, {
    method: 'PUT',
    data: JSON.stringify(giftcard),
  });
};

export const createGiftcard = async (companyId: string, giftcard: Partial<Giftcard>) => {
  return fetcher(`${API_URL}/v1/company/${companyId}/giftcards`, {
    method: 'POST',
    data: JSON.stringify(giftcard),
  });
};

export const deleteGiftcard = async (companyId: string, giftcardId: string) => {
  return fetcher(`${API_URL}/v1/company/${companyId}/giftcards/${giftcardId}`, {
    method: 'DELETE',
  });
};
